import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
/**
 * Provider wrapper service for `MatSnackBar` service
 */
@Injectable({providedIn:'root'})
export class LsSnackbarService {
  /**
   * Constructor
   * @param snackBar 
   */
  constructor(private snackBar: MatSnackBar) { }
  /**
   * Opens a snackbar with a message and an optional action.
   * @param message The message to show in the snackbar.
   * @param action The label for the snackbar action. 
   * @param duration Duration of the snack bar
   * @param horizontal_position The horizontal position to place the snack bar. 
   * @param vertical_pos The vertical position to place the snack bar
   * @param panelClass Extra CSS classes to be added to the snack bar container.
   */
  public open(message: string, action: string, duration: number, horizontal_position?, vertical_pos?, panelClass?: string[]): any {
    // return this.snackBar.open(message, action, { 'duration': duration });
    let value: any = { 'duration': duration }
    if (horizontal_position) {
      value['horizontal_position'] = 'center'      //horizontal_position
    }
    if (vertical_pos) {
      value['vertical_pos'] = 'top'  // vertical_pos
    }
    if (panelClass && panelClass.length != 0) {
      value['panelClass'] = [...panelClass]    //extraClasses
    }
    return this.snackBar.open(message, action, value);
  }

 /**
  * Dismisses the currently-visible snack bar.
  */
  public dismiss(): void {
    this.snackBar.dismiss();
  }

}
